module.exports = __webpack_public_path__ + "static/media/lieux.6e7ede00.md";